module.exports = __webpack_public_path__ + "media/images/konintodoke/other_services/logo06-658819b0d571a6b49239fc776c853c06.png";